import request from './request'

export function listWorkstationType(data) {
  return request.post('/mes/workstation-types/list', data)
}
export function selectWorkstationType() {
  return request.get('/mes/workstation-types/select')
}
export function getWorkstationType(id) {
  return request.get('/mes/workstation-types/' + id)
}
export function saveWorkstationType(data) {
  return request.post('/mes/workstation-types', data)
}
export function updateWorkstationType(data) {
  return request.post('/mes/workstation-types/update', data)
}
export function deleteWorkstationType(ids) {
  return request.post('/mes/workstation-types/delete', ids)
}
